import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import ModuleList from '../../../layout/ModuleList';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import {
  NEW_PREVENTIVE_TASK_ASSIGNEE_PATH,
  PREVENTIVE_TASK_ASSIGNEE_PATH,
} from '../../../../config/paths';
import { PREVENTIVE_TASK_ASSIGNEE_COLUMNS } from '../../../../config/columns';
import {
  clearPreventiveTaskAssignees,
  getPreventiveTaskAssignees,
} from '../../../../actions/task-schedule/PreventiveTaskAssignee';

export const PreventiveTaskAssignees = ({
  breadcrumbs,
  preventiveTasks,
  loading,
  dispatchGetPreventiveTaskAssignees,
  dispatchClearPreventiveTaskAssignees,
}) => {
  useLayoutEffect(() => () => dispatchClearPreventiveTaskAssignees(), []);

  const data = preventiveTasks.get('content') || [];
  const pages = preventiveTasks.get('totalPages') || null;
  const defaultPageSize = preventiveTasks.get('size') || DEFAULT_PAGE_SIZE;

  return (
    <ModuleList
      title="Lista de Asignaciones de Tareas Programadas"
      breadcrumbs={breadcrumbs}
      buttonPath={NEW_PREVENTIVE_TASK_ASSIGNEE_PATH}
      tableStructure={{
        columns: PREVENTIVE_TASK_ASSIGNEE_COLUMNS,
        data,
        pages,
        defaultPageSize,
        filterable: true,
        fetchData: dispatchGetPreventiveTaskAssignees,
        modelPath: PREVENTIVE_TASK_ASSIGNEE_PATH,
        loading,
        navigateToModelOnRowClick: true,
      }}
    />
  );
};

const mapDispatchToProps = {
  dispatchGetPreventiveTaskAssignees: getPreventiveTaskAssignees,
  dispatchClearPreventiveTaskAssignees: clearPreventiveTaskAssignees,
};

const mapStateToProps = ({ TaskScheduleUnit }) => ({
  breadcrumbs: [
    ...TaskScheduleUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Lista de Asignaciones de Tareas Programadas',
      href: PREVENTIVE_TASK_ASSIGNEE_PATH,
    },
  ],
  preventiveTasks: TaskScheduleUnit.PreventiveTaskAssignee.getIn([
    'all',
    'content',
  ]),
  loading: TaskScheduleUnit.PreventiveTaskAssignee.getIn(['all', 'loading']),
});

PreventiveTaskAssignees.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  preventiveTasks: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetPreventiveTaskAssignees: PropTypes.func.isRequired,
  dispatchClearPreventiveTaskAssignees: PropTypes.func.isRequired,
};

PreventiveTaskAssignees.defaultProps = {
  preventiveTasks: null,
  loading: false,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PreventiveTaskAssignees);
